import * as Yup from 'yup';
import { INVALID_FIELDS, YupString, YupStringWithoutRequired } from './general';

const dateInfoSchema = Yup.object().shape({
  from: YupStringWithoutRequired.nullable(),
  to: YupStringWithoutRequired.nullable(),
});
export const kitFilterSchema = Yup.object().shape({
  projectIds: Yup.array().of(Yup.string().nullable()),
  orderDate: dateInfoSchema,
  orderConfirmedDate: dateInfoSchema,
  kitReceivedDate: dateInfoSchema,
});

export const markKitReceivedSchema = Yup.object().shape({
  expectDate: Yup.date().required(INVALID_FIELDS.REQUIRED),
});

export const profileNameSchema = Yup.object().shape({
  firstName: YupString,
  lastName: YupString,
  birthdate: YupString,
});

// Dna Sample Schema
const dnaSampleSchema = {
  volume: YupStringWithoutRequired.nullable(),
  boxNumber: YupStringWithoutRequired.nullable(),
};
export const createDnaSampleSchema = Yup.object().shape({
  sampleType: YupString,
  ...dnaSampleSchema,
});
export const UpdateDnaSampleSchema = Yup.object().shape(dnaSampleSchema);

// Sample Schema fields optional
export const fmtDataSchema = Yup.object().shape({
  timeOfArrival: YupStringWithoutRequired.nullable(),
  weightOfStool: YupStringWithoutRequired.nullable(),
  startOfProcess: YupStringWithoutRequired.nullable(),
  endOfProcess: YupStringWithoutRequired.nullable(),
  finalWeightOfStool: YupStringWithoutRequired.nullable(),
});
export const createSampleSchema = Yup.object().shape({
  sampleId: Yup.string()
    .nullable()
    .test('sampleId', INVALID_FIELDS.REQUIRED, (value, values) => {
      const { checkSampleId = false } = values.parent;
      return !checkSampleId || !!value;
    }),
  numberOfSamples: Yup.number()
    .test('positive', 'Positive number', value => {
      if ((value && value < 0) || value === 0) return false;
      return true;
    })
    .required(INVALID_FIELDS.REQUIRED),
  sampleType: YupStringWithoutRequired,
  stoolAliquotMedium: YupStringWithoutRequired,
  boxNumber: YupStringWithoutRequired.nullable(),
  volume: YupStringWithoutRequired.nullable(),
});

export const updateSampleSchema = Yup.object().shape({
  sampleId: YupString,
  sampleType: YupStringWithoutRequired,
  stoolAliquotMedium: YupStringWithoutRequired.nullable(),
  boxNumber: YupStringWithoutRequired.nullable(),
});

export const sendKitToNewSequencingSchemas = (isCreateNewBatch: boolean) => {
  const createSeqBatchSchemas = {
    type: Yup.string().required(INVALID_FIELDS.REQUIRED),
    sequencingPartnerId: Yup.string().required(INVALID_FIELDS.REQUIRED),
  };

  const sendToExistingBatchSchemas = {
    batchId: Yup.string().required(INVALID_FIELDS.REQUIRED),
  };

  return Yup.object().shape(
    isCreateNewBatch ? createSeqBatchSchemas : sendToExistingBatchSchemas,
  );
};
